import * as entityHandlers from '../../../modules/bin/entityHandlers';
import { Record } from '../../../modules/bin/utility';
import { CLEAR } from '../../../modules/general';

import {
    GET_REQUESTED,
    GET_SUCCESS,
    GET_FAILURE,
    FRANCHISE_HISTORY_REQUESTED,
    FRANCHISE_HISTORY_SUCCESS,
    FRANCHISE_HISTORY_FAILURE,
    MARK_SPAM_REQUESTED,
    MARK_SPAM_SUCCESS,
    MARK_SPAM_FAILURE,
    MARK_SPAM_CONFIRMATION_SHOW,
    MARK_SPAM_CONFIRMATION_HIDE,
    ERROR_CLEAR
} from './fundraiserActions';

const initialState = {
    timestamp: new Date().getTime(),
    record: Record.getDefaultState(),
    franchiseHistory: Record.getDefaultState(),
    organizationRecord: Record.getDefaultState(),
    saveRecord: Record.getDefaultState(),
    markSpamConfirmation: false
};

// State Reducer
const fundraiserReducer = (state = initialState, action: any) => {
    let newState;
    switch (action.type) {
        case GET_REQUESTED:
            newState = entityHandlers.getRecordRequestedHandler(state, action);
            break;

        case GET_SUCCESS:
            newState = entityHandlers.getRecordSuccessHandler(state, action);
            break;

        case GET_FAILURE:
            newState = entityHandlers.crudErrorHandler(state, action);
            break;

        case FRANCHISE_HISTORY_REQUESTED:
            newState = entityHandlers.getRecordRequestedHandler(state, action);
            break;

        case FRANCHISE_HISTORY_SUCCESS:
            newState = entityHandlers.getRecordSuccessHandler(state, action);
            break;

        case FRANCHISE_HISTORY_FAILURE:
            newState = entityHandlers.crudErrorHandler(state, action);
            break;

        case MARK_SPAM_REQUESTED:
            newState = {
                ...state,
                saveRecord: {
                    ...Record.getDefaultState(),
                    ready: 1 // RECORD_STATUS_LOADING
                }
            };
            break;

        case MARK_SPAM_SUCCESS:
            newState = entityHandlers.getRecordSuccessHandler(state, action);
            break;

        case MARK_SPAM_FAILURE:
            newState = {
                ...state,
                saveRecord: {
                    ...state.saveRecord,
                    ready: -3, // RECORD_STATUS_ERROR
                    error: {
                        show: true,
                        errorKeys: action.payload?.error?.map((e: any) => e.error) ?? null
                    }
                }
            };
            break;

        case MARK_SPAM_CONFIRMATION_SHOW:
            newState = { ...state, markSpamConfirmation: true };
            break;

        case MARK_SPAM_CONFIRMATION_HIDE:
            newState = { ...state, markSpamConfirmation: false, saveRecord: Record.getDefaultState() };
            break;

        case ERROR_CLEAR:
            newState = entityHandlers.crudClearErrorHandler(
                state,
                action.payload.key
            );
            break;

        case CLEAR: {
            newState = initialState;
            break;
        }
        default:
            newState = state;
            break;
    }

    return newState;
};

export default fundraiserReducer;
